import React from 'react';
interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  className?: string;
  /** Pass -1 to remove the button from the tab order (e.g. while visually hidden). */
  tabIndex?: number;
}
export function PrimaryButton({
  children,
  onClick,
  href,
  size = 'lg',
  fullWidth = false,
  className = '',
  tabIndex
}: PrimaryButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  const sharedClassName = `inline-flex items-center justify-center ${sizeClasses} ${fullWidth ? 'w-full' : ''} rounded-2xl border-2 border-naranja bg-marino font-heading font-bold uppercase tracking-wide text-white shadow-media transition-colors duration-200 hover:bg-marino-dark active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-azul focus-visible:ring-offset-2 ${className}`;
  if (href) {
    return <a href={href} onClick={onClick} tabIndex={tabIndex} className={sharedClassName} data-id="element-280" data-mp="grgg4grv0ur0">
        {children}
      </a>;
  }
  return <button onClick={onClick} tabIndex={tabIndex} className={sharedClassName} data-id="element-281" data-mp="bru3a8fy1giq">
      {children}
    </button>;
}